<template>
	<div :class="['item_sidebar input_number_block small-number-prop', addedClass]">
		<div class="wrapper_title wrapper_body mb_0">
			<div class="title" v-if="title !== 'withoutTitle'">{{ title }}</div>
			<input-field type="number" small :value.number="value.number" :append="value.append||''" :placeholder="value.placeholder"
			             @change="inputDataUpdate($event)" :min="value.min" :step="0.1" :max="100.00"/>
		</div>
	</div>
</template>

<script>
import InputField from '@/components/base/input-field';

export default {
	name: 'SmallNumber',
	props: ['value', 'title', 'addedClass'],
	components: {InputField},
	data: function () {
		return {
			numberValue: {
				append: 'px',
				number: 0.00,
				min: -100.00,
			},
		}
	},
	methods: {
		inputDataUpdate(val) {
			if (val) {
				this.numberValue.number = parseFloat(val);
			} else this.numberValue.number = null;

			if (this.addedClass !== 'single_item') {
				this.$emit('updated', this.numberValue);
			} else {
				this.$emit('inputNumberUpdate', this.numberValue);
			}
		},
	},
	created() {
		this.numberValue = JSON.parse(JSON.stringify(this.value));
	}
}
</script>
<style lang="scss" scoped>
.small-number-prop {
	.input-field {
		width: 100px;
	}
}
</style>
